export default function TransactionFinderFilter(transactionFinder) {
	let withBankTransactions = false;
	let onlyBankTransactions = false;
	let withVisibleUserTransactions = false;
	let showHiddenBankAccountTransactions = false;

	/**
	 * Exclude deleted transactions
	 */
	this.setWithVisibleUserTransactions = (set) => {
		withVisibleUserTransactions = set;
		return this;
	};


	/**
	 * With this filter active, bank transactions that are not assigned to a transaction will be mixed with the results
	 */
	this.setWithBankTransactions = (set) => {
		withBankTransactions = set;
		return this;
	};

	/**
	 * With this filter active, only the bank transactions are returned: the unlinked ones that
	 * setWithBankTransactions mixes in, without the budget's own transactions around them.
	 */
	this.setOnlyBankTransactions = (set) => {
		onlyBankTransactions = set;
		return this;
	};

	this.setShowHiddenBankAccountTransactions = (set) => {
		showHiddenBankAccountTransactions = set;
		return this;
	};

	/**
	 *
	 * @param dates
	 * @returns {[Transaction]}
	 */
	this.getTransactionsByDates = (dates) => {
		let transactions = transactionFinder.getTransactionsByDate(dates);

		if(withVisibleUserTransactions) {
			transactions = transactions.filter((transaction) => {
				return !transaction.deleted;
			});
		}

		let transactionsToDisplay = transactions.map((transaction) => {
			return transaction.clone(); //So that we edit a copy
		});

		if(withBankTransactions) {
			transactionsToDisplay = addBankTransactions(transactionsToDisplay, dates);
		}
		if(onlyBankTransactions) {
			transactionsToDisplay = transactionsToDisplay.filter((transaction) => transaction.isBankTransaction());
		}
		return transactionsToDisplay;
	};

	const addBankTransactions = (transactionsToDisplay, selectedDates) => {
		const plaidTransactionsAlreadyMergedWithRegularTransactions = {};
		const bankTransactions = transactionFinder.plaidTransactions.byDates(selectedDates);
		if(bankTransactions && bankTransactions.length) {
			for(let transaction of transactionsToDisplay) {
				if(transaction.plaid_transaction_id) {
					plaidTransactionsAlreadyMergedWithRegularTransactions[transaction.plaid_transaction_id] = true;
				}
			}
			transactionsToDisplay = bankTransactions.filter((bankTransaction) => {
				if(plaidTransactionsAlreadyMergedWithRegularTransactions[bankTransaction.plaid_transaction_id]) {
					//This transaction is already merged with a regular transaction, so it should be hidden
					return false;
				}
				if(plaidTransactionsAlreadyMergedWithRegularTransactions[bankTransaction.plaid_pending_transaction_id]) {
					//Is a completed transaction, BUT a parent transaction is already assigned
					return false;
				}
				if(transactionFinder.plaidTransactions.transactionsThatHavePendingParent[bankTransaction.plaid_transaction_id]) {
					//Has a "Newer" transaction on the list now
					return false;
				}
				if((!showHiddenBankAccountTransactions && bankTransaction.hidden)) {
					return false;
				}
				return true;
			}).concat(transactionsToDisplay).sort((a, b) => {
				if(!a.transaction_date) {
					return -1;
				}
				if(!b.transaction_date) {
					return 1;
				}
				if(a.transaction_date.isSame(b.transaction_date, 'second')) {
					if(a.plaid_transaction_id && b.plaid_transaction_id) {
						return a.plaid_transaction_id > b.plaid_transaction_id ? 1 : -1;
					}
					return 0;
				}

				if(a.transaction_date.isAfter(b.transaction_date)) {
					return -1;
				} else {
					return 1;
				}
			});
		}
		return transactionsToDisplay;
	};

	return this;
}
